import MicroFrontend from "../_micro-frontend/MicroFrontend";

const Soundbites = (function () {
  // Add the defined element to the custom elements registry
  customElements.define("micro-frontend", MicroFrontend);

  return {
    init: () => {},
  };
})();

export default Soundbites;
